import { CreateProductCategoryRequest } from '../dto/CreateProductCategoryRequest';
import { PagedResponse } from '../dto/PagedResponse';
import { ProductCategoryDto } from '../dto/ProductCategoryDto.dto';
import { UpdateProductCategoryRequest } from '../dto/UpdateProductCategoryRequest';

import {
    ApiProductCategory,
    ApiProductCategoryListResponse,
    IProductCategoryMapper,
    ProductCategoryApiPayload,
} from './IProductCategoryMapper';

export class ProductCategoryMapper implements IProductCategoryMapper {
    toDto(item: ApiProductCategory): ProductCategoryDto {
        return {
            id: item.id,
            externalId: item.id,
            name: item.name,
            type: item.type,
            backgroundColor: item.background_color ?? null,
            description: item.description ?? null,
            createdDate: item.created_at ?? '',
            status: item.status ?? 'ACTIVE',
        };
    }

    toPagedResponse(
        response: ApiProductCategoryListResponse,
    ): PagedResponse<ProductCategoryDto> {
        return {
            content: (response.content ?? []).map(item => this.toDto(item)),
            page: response.page ?? 0,
            size: response.size ?? 0,
            total_elements: response.total_elements ?? 0,
            total_pages: response.total_pages ?? 0,
        };
    }

    toApiPayload(
        request: CreateProductCategoryRequest | UpdateProductCategoryRequest,
    ): ProductCategoryApiPayload {
        return {
            name: request.name,
            type: request.type,
            background_color: request.backgroundColor,
            description: request.description,
        };
    }
}